import { getItemUniqueKey, getPackageId } from 'checkout/lib/utils/accommodation/cart'
import { computeCabinPricing } from 'checkout/lib/utils/cruises/pricing'
import { CHECKOUT_ITEM_TYPE_CRUISE } from 'constants/checkout'
import { OFFER_TYPE_CRUISE } from 'constants/offer'

export function isCruiseOfferView(
  view: App.Checkout.AccommodationOfferView,
): view is App.Checkout.CruiseAccommodationOfferView {
  return view.offerType === OFFER_TYPE_CRUISE
}

function dummyCruiseItemView(
  item: App.Checkout.CruiseItem,
  kind: 'cruise',
): App.Checkout.CruiseAccommodationItemView {
  return {
    kind,
    packageId: getPackageId(item),
    uniqueKey: getItemUniqueKey(item),
    item,
    mainLabel: '',
    occupancy: { adults: 0, children: 0 },
    price: 0,
    value: 0,
    surcharge: 0,
    taxesAndFees: 0,
    removeLabel: 'remove',
  }
}

export function buildCruiseItemView(
  item: App.Checkout.CruiseItem,
  offer?: App.CruiseOffer,
  rateView?: App.CruiseCabinRateView,
  cabinHold?: App.CruiseCabinHold | null,
  rateDetails?: App.CruiseCabinRateDetailsResponse,
  cabinPricing?: App.CruiseCabinPricing | null,
): App.WithDataStatus<App.Checkout.CruiseAccommodationItemView> {
  if (!offer) {
    return {
      hasRequiredData: false,
      data: dummyCruiseItemView(item, CHECKOUT_ITEM_TYPE_CRUISE),
    }
  }

  const departures = offer.departures ? Object.values(offer.departures).flat() : []
  const departureTarget = departures.find(departure => departure.id === item.departureId)

  const mainLabel = rateView?.pricedCategoryCode || ''
  const ship = offer.ship

  const cabinCategory = ship?.cabinCategories ?
    ship.cabinCategories.find(category => category.code === item.cabinCode) :
    null

  const { taxesAndFees, price } = computeCabinPricing(cabinHold?.pricing, cabinPricing?.pricing)

  return {
    hasRequiredData: true,
    data: {
      item,
      kind: CHECKOUT_ITEM_TYPE_CRUISE,
      packageId: item.departureId,
      uniqueKey: item.departureId,
      departure: departureTarget,
      mainLabel,
      cabinRateView: rateView,
      occupancy: item.occupancy,
      surcharge: 0,
      price,
      taxesAndFees,
      ...(cabinCategory && { cabinCategory }),
      ...(cabinHold && { cabinHold }), // loads after 'cabin-location' page
      ...(cabinPricing && { cabinPricing }), // loads after 'cabin-hold'
      ...(rateDetails && { rateDetails }),

      // Accommodation specific attributes
      removeLabel: 'remove',
      value: undefined,
    },
  }
}
